import { Stack } from "@chakra-ui/react";
import { FC } from "react";
import { Control } from "react-hook-form";
import AccountSystemDataForm from "./AccountSystemDataForm";
import PersonalDataForm from "../../Users/forms/PersonalDataForm";

interface AccountSubmitFormProps {
  errors: any;
  control: Control<any>;
  handlePasswordReset?: () => void;
  selectedRole?: any | undefined;
  isDisabled?: boolean;
  isSystemDisabled?: boolean;
}

const AccountSubmitForm: FC<AccountSubmitFormProps> = ({
  errors,
  control,
  handlePasswordReset,
  selectedRole,
  isDisabled,
  isSystemDisabled = false,
}) => {
  return (
    <>
      <Stack spacing={8}>
        <PersonalDataForm
          errors={errors}
          control={control}
          handlePasswordReset={handlePasswordReset}
          isDisabled={isDisabled}
        />
        <AccountSystemDataForm
          selectedRole={selectedRole}
          errors={errors}
          control={control}
          isDisabled={isDisabled || isSystemDisabled}
        />
      </Stack>
    </>
  );
};

export default AccountSubmitForm;
